import _ from 'underscore';
import { parseSync } from '@bingads-webui/safe-json';
import { getTitlePreview } from '@bingads-webui-campaign/summary-grid-helper';
import {
  responsiveAdPreviewTemplate,
  dynamicSearchAdPreviewTemplate
} from '@bingads-webui-campaign/ad-previews';

const adTypes = {
  textAds: 'TextAd',
  expandedTextAds: 'ExpandedTextAd',
  appInstallAds: 'AppInstallAd',
  dynamicSearchAds: 'DynamicSearchAd',
  responsiveAds: 'ResponsiveAd',
  responsiveSearchAds: 'ResponsiveSearchAd',
};

const getAdType = function (entityValues) {
  if (entityValues.AdTitle2) {
    return adTypes.expandedTextAds;
  } else if (entityValues.AdHeadline && entityValues.AdBusinessName) {
    return adTypes.responsiveAds;
  } else if (_.has(entityValues, 'AdHeadlines')) {
    return adTypes.responsiveSearchAds;
  } else if (
    _.has(entityValues, 'AdPath1') &&
    _.has(entityValues, 'AdPath2') &&
    !_.has(entityValues, 'AdTitle')
  ) {
    return adTypes.dynamicSearchAds;
  }
  return adTypes.textAds;
};

const getGenericAdPreview = function (entityValues) {
  let previewValue = '';

  // if AdTitle is there, use it
  previewValue = entityValues.AdTitle;

  return previewValue;
};

const getResponsiveSearchAdPreview = function (entityValues) {
  let previewValue = '';

  let values = parseSync(entityValues.AdHeadlines);
  if (!_.isEmpty(values)) {
    values = _.map(values, value => parseSync(value));

    previewValue = getTitlePreview(values);
  }

  return previewValue;
};

const getResponsiveAdPreview = function (entityValues, i18n) {
  return responsiveAdPreviewTemplate({
    itemViewModel: {
      LandscapeImageMediaUrl: entityValues.OriginalImageMediaUrl || entityValues.LandscapeImageMediaUrl,
      Headline: entityValues.AdHeadline,
      LongHeadline: entityValues.AdLongHeadline,
      Text: entityValues.AdText,
      BusinessName: entityValues.AdBusinessName,
      convertedDisplayUrl: entityValues.AdDisplayUrl,
    },
    i18n,
    withContainer: true,
  });
};

const getDynamicSearchAdPreview = function (entityValues, i18n) {
  return dynamicSearchAdPreviewTemplate({
    itemViewModel: {
      DisplayUrl: entityValues.AdDisplayUrl,
      Path1: entityValues.AdPath1,
      Path2: entityValues.AdPath2,
      Text: entityValues.AdText,
    },
    i18n,
  });
};

const getAdEntityPreviewCell = function (entityValues, i18n) {
  const adType = getAdType(entityValues);

  switch (adType) {
    case adTypes.responsiveSearchAds:
      return { value: getResponsiveSearchAdPreview(entityValues), isHtml: false };

    case adTypes.responsiveAds:
      return { value: getResponsiveAdPreview(entityValues, i18n), isHtml: true };

    case adTypes.dynamicSearchAds:
      return { value: getDynamicSearchAdPreview(entityValues, i18n), isHtml: true };

    case adTypes.expandedTextAds:
    default:
      return { value: getGenericAdPreview(entityValues), isHtml: false };
  }
};

export { getAdEntityPreviewCell };
